var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"banner-brand-image-content"},[_c('div',{staticClass:"banner-brand-image",style:({ backgroundImage: `url(${_vm.bannerImageSrc})` })}),_c('div',{staticClass:"overlay-brand-image"},[_c('h1',{staticClass:"banner-brand-title"},[_vm._v(_vm._s(_vm.bannerImageTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }